<template>
  <div class='video-wrapper' ref="videoWrapper"
  :class="{ 'pseudo-fullscreen': isPseudoFullscreen, isFullscreen: deviceIsFullscreen }"
  @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd" >
    <div class="loadingPage" :class="{'still-loading': videoState !== 'playing'}"
    :style="getLoadingBgStyle()"></div>
    <canvas class="canvas" ref="canvas" v-shown="setupCanvas" v-if="showCanvas"></canvas>
    <video class="video" ref='video' poster="../assets/black.jpeg"
    playsinline webkit-playsinline autoplay muted
    @loadeddata="captureImage" @play="captureImage" @canplay="captureImage">
    </video>
    <div class="tapBack" v-if="showCanvas">
      <div @click="backTap"></div>
      <div class="symbol">
        <transition name="fade" mode="out-in">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-fast-forward-circle" viewBox="0 0 16 16">
            <!-- eslint-disable-next-line max-len -->
            <path v-if="symbolShown" d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <!-- eslint-disable-next-line max-len -->
            <path v-if="symbolShown == '>>'"  d="M4.271 5.055a.5.5 0 0 1 .52.038L8 7.386V5.5a.5.5 0 0 1 .79-.407l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 8 10.5V8.614l-3.21 2.293A.5.5 0 0 1 4 10.5v-5a.5.5 0 0 1 .271-.445"/>
            <!-- eslint-disable-next-line max-len -->
            <path v-if="symbolShown == '<<'" d="M7.729 5.055a.5.5 0 0 0-.52.038l-3.5 2.5a.5.5 0 0 0 0 .814l3.5 2.5A.5.5 0 0 0 8 10.5V8.614l3.21 2.293A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407L8 7.386V5.5a.5.5 0 0 0-.271-.445"/>
          </svg>
        </transition>
      </div>
      <div @click="forwardTap"></div>
    </div>
    <div class="mediaTools" :class="{'still-loading': videoState !== 'playing'}" ref="mediaTools">
      <button class="playPause" @click="togglePlay">
        <svg v-if=" playingState(playing) == 'pause'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause" viewBox="0 0 16 16">
          <!-- eslint-disable-next-line max-len -->
          <path d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play" viewBox="0 0 16 16">
          <!-- eslint-disable-next-line max-len -->
          <path d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5m4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5"/>
        </svg>
      </button>
      <button class="daySkip" @click="() => skipDay(-1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-left" viewBox="0 0 16 16">
          <!-- eslint-disable-next-line max-len -->
          <path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
          <!-- eslint-disable-next-line max-len -->
          <path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
        </svg>
      </button>
      <span
      class="time-text" ref="timeText" :style="{ fontSize: timeFontRem + 'rem' }" v-show="showTime"
      @click="openDatePicker"
      >
      <input
          type="datetime-local"
          ref="dateInput"
          @change="onDateSelected"
          :max="new Date(Date.now()).toISOString().slice(0,16)"
        style="width: 1px; opacity: 0; border: 0; height: 1px; position: absolute; bottom: 0px;"
        />
        <span class="DDMMYYYY" v-show="showDate">
          {{ displayDate[0] }}
        </span>
        <span class="HHMMSS">
          {{ displayDate[1] }}
        </span>
      </span>
      <button class="daySkip" @click="() => skipDay(1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
          <!-- eslint-disable-next-line max-len -->
          <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708"/>
          <!-- eslint-disable-next-line max-len -->
          <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708"/>
        </svg>
      </button>
      <div class="filters">
        <div
          class="filterIcon refresh"
          @click="refreshEvents()"
        ></div>
        <div class="filterSpacer"></div>
        <div
          class="filterIcon car"
          :class="{enabled: eventsEnabled.v}"
          @click="toggleFilter('v')"
        ></div>
        <div
          class="filterIcon human"
          :class="{enabled: eventsEnabled.p}"
          @click="toggleFilter('p')"
        ></div>
      </div>
      <div class="barPlaceholder"></div>
      <button class="image-capture-btn portraitHide" @click="doJpegCapture"></button>
      <button class="Lv" @click="lvMode" :class="playmode | playmodeFilter">LV</button>
      <button class="fullscreenBtn" :class="{ active: isFullscreen || isPseudoFullscreen }"
      @click="toggleFullscreen" aria-label="Toggle Fullscreen">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-fullscreen" viewBox="0 0 16 16">
        <path
        d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0
        1zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0
        0-.5-.5h-4a.5.5 0 0 1-.5-.5M.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0
        1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5
        1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5"/>
      </svg>
      </button>
    </div>

    <loading-wheel class="loading" v-if="isLoading" :time="20" :slowTime="40"
    initialMessage="Connecting to camera..." hideBar style="height: calc(100% - 76px);"/>

    <!-- Error overlay -->
    <div class="errorOverlay" v-if="videoState === 'error'">
      <div class="errorCard">
        <div class="errorTitle">Stream error</div>
        <div class="errorBody">
          {{ videoError || 'Failed to start the video stream.' }}
          <div v-if="lastJanusError" class="errorDetails">{{ lastJanusError }}</div>
          <div class="errorDetails">
            <button @click="hardReload">Reload</button>
          </div>
        </div>
      </div>
    </div>

    <div class="timelineScrubberSlot">
      <slot />
    </div>
  </div>
</template>

<script>

import { get, set, keys } from 'idb-keyval';

import adapter from 'webrtc-adapter';
import screenfull from 'screenfull';
import Janus from '../../public/janus';
import awsInfo from '../../public/websocket';
import LoadingWheel from './LoadingWheel.vue';

export default {
  props: {
    connectDelayMs: { type: Number, default: 1000 },
    camera: { /* Ignore */ },
  },
  filters: {
    playmodeFilter(playmode) {
      if (playmode === 'lv') {
        return 'redHighlight';
      }
      return false;
    },
  },
  directives: {
    shown: {
      inserted: (el, binding, vnode) => {
        const func = vnode.context[binding.expression];
        if (typeof (func) === 'function') func();
      },
    },
  },
  components: { LoadingWheel },
  name: 'LiveVideo',
  computed: {
    selectedEvent() {
      return this.$store.getters.selectedEvent;
    },
    filterTime() {
      return this.$store.getters.filterTime;
    },
    eventTo() {
      return this.$store.getters.eventTo;
    },
    displayDate() {
      let formattedDate;
      if (this.lastTimeStamp) formattedDate = this.formatDate(new Date(this.lastTimeStamp));
      else formattedDate = this.formatDate(this.parseDateTime(this.currentDate));
      return formattedDate.split(' ');
    },
    // Drive all “loading” visuals from state
    isLoading() {
      return this.videoState !== 'playing' && this.videoState !== 'error';
    },
    deviceIsFullscreen() {
      if (this.isIPhone()) return this.isPseudoFullscreen;
      return this.isFullscreen;
    },
  },
  data() {
    return {
      // --- Responsive toolbar state ---
      showDate: true,
      showTime: true,
      showNavButtons: true,
      timeFontRem: 1,
      minTimeFontRem: 0.75,
      toolbarRO: null,

      isFullscreen: false,
      isPseudoFullscreen: false,
      swipe: {
        active: false, startX: 0, startY: 0, time: 0, fromUI: false,
      },

      connectAllowedAt: 0,
      connectTimer: null,
      reconnectTimer: null,
      janusDestroying: false,
      janus: null,
      server: 'wss://127.0.0.1/janus',
      streaming: null,

      videoState: 'connecting', // connecting | negotiating | buffering | playing | error
      videoError: '',
      lastJanusError: '',
      startTimeoutId: null,
      startTimeoutMs: 65000, // Make sure this matches the LoadingWheel time + ~5s
      janusRetries: 0,
      maxJanusRetries: 2,

      error: '',
      lifetimer: null,
      capturingImage: false,
      draw: true,
      playing: null,
      scrubber: 50,
      dbTapForwards: null,
      dbTapBackwards: null,
      symbolShown: '',
      dataChannelOpen: false,
      seekTask: null,
      ignoreTimestampMessages: 0,
      lastTimeStamp: 0,
      playmode: 'lv',
      showCanvas: false,
      previewExists: false,
      previewImage: '',
      clipStatus: 'not-created',
      currentDate: '1.1.1970 00:00:00',
      retryCount: 3,
      jpegFilename: '',
      cancelledScreenshots: [],
      firstStreamTime: true,
      firstInboxRequested: true,
      firstInboxReceived: true,
      firstVideoPlay: true,
      pageLoadTime: Date.now(),
      captureBlockUntil: 0,
      captureIntervalMs: 10000,
      captureTimerId: null,

      eventsEnabled: { v: false, p: false },
    };
  },
  mounted() {
    // Restore persisted fullscreen preference
    try {
      if (sessionStorage.getItem('livevideo.fullscreen') === '1') {
        this.$nextTick(() => this.enterFullscreen());
      }
    } catch (_) { /* Ignore */ }
    // Listen for browser fullscreen changes
    this.onFsChange = () => {
      this.isFullscreen = !!document.fullscreenElement;
      if (!this.isFullscreen) {
        try { sessionStorage.setItem('livevideo.fullscreen', '0'); } catch (_) { /* Ignore */ }
      }
    };
    this.blockCaptures(1000);
    document.addEventListener('fullscreenchange', this.onFsChange);

    // gate initial connection
    this.connectAllowedAt = Date.now() + this.connectDelayMs;
    this.initJanus();
    const v = this.$refs.video;
    v.addEventListener('playing', this.onVideoPlaying);
    v.addEventListener('canplay', this.onVideoCanPlay);
    v.addEventListener('loadedmetadata', this.onVideoLoaded);
    v.addEventListener('waiting', this.onVideoWaiting);
    v.addEventListener('stalled', this.onVideoWaiting);
    v.addEventListener('error', this.onVideoElementError);
    v.addEventListener('pause', this.handlePause);
    v.addEventListener('play', this.handlePlay);

    window.addEventListener('resize', this.handleResize);

    // Initialize toolbar fitting logic
    this.$nextTick(() => this.fitToolbar());
    try {
      this.toolbarRO = new ResizeObserver(() => this.fitToolbar());
      const wrap = this.$el.querySelector('.mediaTools');
      if (wrap) this.toolbarRO.observe(wrap);
    } catch (e) { /* ResizeObserver not supported */ }
    this.setPreviewExists();
    this.loadPreviewImage();
    setTimeout(() => {
      this.captureImage();
    }, 10000);
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.onFsChange);

    try {
      if (this.toolbarRO) {
        this.toolbarRO.disconnect();
        this.toolbarRO = null;
      }
    } catch (_) { /* ignore */ }
    try { this.teardownJanus('beforeDestroy'); } catch (e) { /* ignore */ }
    this.$store.dispatch('incrementAndSaveStat', ['videoFeedStopped']);
    try {
      this.switchToLiveview();
    } catch (e) {
      console.error('beforeDestroy switchToLiveview: ', e);
    }
    try {
      this.stopStream();
    } catch (e) {
      console.error('beforeDestroy stopStream: ', e);
    }
    if (this.janus) this.janus.destroy();
    if (this.lifetimer != null) clearTimeout(this.lifetimer);
    if (this.startTimeoutId) clearTimeout(this.startTimeoutId);

    const v = this.$refs.video;
    v.removeEventListener('playing', this.onVideoPlaying);
    v.removeEventListener('canplay', this.onVideoCanPlay);
    v.removeEventListener('loadedmetadata', this.onVideoLoaded);
    v.removeEventListener('waiting', this.onVideoWaiting);
    v.removeEventListener('stalled', this.onVideoWaiting);
    v.removeEventListener('error', this.onVideoElementError);
    v.removeEventListener('pause', this.handlePause);
    v.removeEventListener('play', this.handlePlay);

    window.removeEventListener('resize', this.handleResize);
    this.draw = false;
  },
  destroyed() {
    this.clearOverlay();
    this.draw = false;
  },
  watch: {
    selectedEvent() {
      if (this.selectedEvent === null) {
        console.log('no selected event');
      } else {
        this.playmode = 'vt';
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data: {
              abs: this.selectedEvent,
              pause: true,
            },
          },
        };
        this.sendData(message);
      }
    },
    filterTime() {
      this.filter();
    },
    scrubber(v) {
      if (v !== 50) {
        const amount = v - 50;
        console.log(amount);
        if (this.seekTask == null) this.startSeekTask();
      } else {
        this.stopSeekTask();
      }
    },
    camera: {
      id() {
        this.loadPreviewImage();
        this.setPreviewExists();
      },
    },
    lastTimeStamp(newValue) {
      this.$emit('dateChange', newValue);
      this.$nextTick(() => this.fitToolbar());
    },
    eventsEnabled: {
      handler(newValue) {
        this.$emit('filterChange', newValue);
      },
      deep: true,
    },
  },
  methods: {
    playingState(playing) {
      if (playing === true) {
        return 'pause';
      } return 'play';
    },
    // --- Toolbar fitting helpers ---
    outerWidth(el) {
      if (!el) return 0;
      const cs = window.getComputedStyle(el);
      const ml = parseFloat(cs.marginLeft) || 0;
      const mr = parseFloat(cs.marginRight) || 0;
      return (el.offsetWidth || 0) + ml + mr;
    },
    fitToolbar() {
      try {
        const wrap = this.$el && this.$el.querySelector('.mediaTools');
        if (!wrap) return;

        // Reset to defaults before measuring
        this.showDate = true;
        this.showTime = true;
        this.showNavButtons = true;
        this.timeFontRem = 1;

        this.$nextTick(() => {
          const doFit = () => {
            const containerW = wrap.clientWidth || 0;

            const playBtn = this.$el.querySelector('.playPause');
            const imCapBtn = this.$el.querySelector('.image-capture-btn');
            const lvBtn = this.$el.querySelector('.Lv');
            const fsBtn = this.$el.querySelector('.fullscreenBtn');
            const timeEl = this.$el.querySelector('.time-text');

            const needs = (el) => {
              if (!el) return 0;
              const prevWs = el.style.whiteSpace;
              // eslint-disable-next-line no-param-reassign
              el.style.whiteSpace = 'nowrap';
              const w = Math.ceil(el.scrollWidth);
              // eslint-disable-next-line no-param-reassign
              el.style.whiteSpace = prevWs;
              return w;
            };

            const leftW = this.outerWidth(playBtn);

            const rightWBase = () => this.outerWidth(fsBtn)
          + this.outerWidth(imCapBtn)
          + this.outerWidth(lvBtn);

            const rightWWithNav = () => rightWBase();

            const availableFor = (showNav) => {
              const rightW = showNav ? rightWWithNav() : rightWBase();
              return Math.max(0, containerW - leftW - rightW - 12);
            };

            const fitTimeToAvailable = (avail) => {
              const minRem = this.minTimeFontRem || 0.75;

              // Try full size first
              this.timeFontRem = 1;
              if (needs(timeEl) <= avail) return true;

              // Binary search the largest size in [minRem, 1] that fits
              let lo = minRem;
              let hi = 1;
              let best = null;

              for (let i = 0; i < 12; i += 1) {
                const mid = (lo + hi) / 2;
                this.timeFontRem = mid;
                if (needs(timeEl) <= avail) {
                  best = mid;
                  lo = mid; // can try larger
                } else {
                  hi = mid; // must go smaller
                }
              }

              if (best != null) {
                this.timeFontRem = Math.max(minRem, best);
                return true;
              }

              // Even at min size it may not fit
              this.timeFontRem = minRem;
              return needs(timeEl) <= avail;
            };

            // Step 1: with date shown
            if (needs(timeEl) <= availableFor(true)) return;

            // Step 2: hide date
            this.showDate = false;
            this.$nextTick(() => {
              if (needs(timeEl) <= availableFor(true)) return;

              // Step 3: shrink time to fit (down to min)
              fitTimeToAvailable(availableFor(true));
            });
          };

          doFit();
        });
      } catch (e) {
        console.warn('fitToolbar error', e);
      }
    },

    // --- Swipe navigation (left/right) ---
    onTouchStart(e) {
      // Preserve existing double-tap prevention logic
      if (typeof this.preventZoom === 'function') {
        try { this.preventZoom(e); } catch (_) { /* ignore */ }
      }
      // Ignore multi-touch (pinch/zoom)
      if (!e || !e.touches || e.touches.length !== 1) {
        this.swipe.active = false;
        return;
      }
      const t = e.touches[0];
      // Avoid starting a swipe from UI controls (prev/next buttons, timeline scrubber, etc.)
      const { target } = e;
      const avoid = (el) => !!(el && el.closest && (el.closest('.mediaTools') || el.closest('.timelineScrubberSlot')));
      if (avoid(target)) {
        this.swipe.active = false;
        this.swipe.fromUI = true;
        return;
      }
      this.swipe.active = true;
      this.swipe.fromUI = false;
      this.swipe.startX = t.clientX;
      this.swipe.startY = t.clientY;
      this.swipe.time = e.timeStamp || performance.now();
    },
    onTouchMove(e) {
      if (!this.swipe.active) return;
      if (!e || !e.touches || e.touches.length !== 1) return;
      const t = e.touches[0];
      const dx = t.clientX - this.swipe.startX;
      const dy = t.clientY - this.swipe.startY;
      // If horizontal movement dominates and exceeds a small threshold, prevent accidental taps
      if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
        if (e.cancelable) e.preventDefault();
      }
    },
    onTouchEnd(e) {
      const s = this.swipe;
      // Reset swipe state early
      this.swipe.active = false;
      if (!s || s.fromUI) return;
      const changed = (e && e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
      const endX = changed ? changed.clientX : s.startX;
      const endY = changed ? changed.clientY : s.startY;
      const dt = (e && e.timeStamp ? e.timeStamp : performance.now())
      - (s.time || performance.now());
      const dx = endX - s.startX;
      const dy = endY - s.startY;
      const absDx = Math.abs(dx);
      const absDy = Math.abs(dy);
      const vx = dt > 0 ? absDx / dt : 0; // px per ms

      // Trigger a swipe when horizontal movement dominates and is either sufficiently long or fast.
      const DIST_THRESHOLD = 60; // pixels
      const SPEED_THRESHOLD = 0.5; // px/ms (~500 px/s)

      const isHorizontal = absDx > absDy * 1.1;
      const passed = (absDx >= DIST_THRESHOLD) || (vx >= SPEED_THRESHOLD);

      if (isHorizontal && passed) {
        // Swipe left -> next camera; Swipe right -> previous camera.
        if (dx < 0) {
          this.$emit('next-camera');
        } else {
          this.$emit('prev-camera');
        }
        // Prevent a trailing click on tap zones
        if (e && e.cancelable) e.preventDefault();
      }
    },
    // --- iOS pseudo-fullscreen helpers ---
    lockScroll() {
      try {
        this.prevDocOverflow = document.documentElement.style.overflow;
        this.prevBodyOverflow = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      } catch (_) { /* Ignore */ }
    },
    unlockScroll() {
      try {
        document.documentElement.style.overflow = this.prevDocOverflow || '';
        document.body.style.overflow = this.prevBodyOverflow || '';
      } catch (_) { /* Ignore */ }
    },
    async enterPseudoFullscreen() {
      this.isPseudoFullscreen = true;
      this.lockScroll();
      try { sessionStorage.setItem('livevideo.fullscreen', '1'); } catch (_) { /* Ignore */ }
    },
    async exitPseudoFullscreen() {
      this.isPseudoFullscreen = false;
      this.unlockScroll();
      try { sessionStorage.setItem('livevideo.fullscreen', '0'); } catch (_) { /* Ignore */ }
    },
    isIPhone() {
      const ua = navigator.userAgent || '';
      return /iPhone/.test(ua) && !/iPad/.test(ua);
    },
    blockCaptures(ms = 1500) {
      this.captureBlockUntil = Date.now() + ms;
    },
    async toggleFullscreen() {
      if (this.isIPhone()) {
        if (this.isPseudoFullscreen) {
          await this.exitPseudoFullscreen();
        } else {
          await this.enterPseudoFullscreen();
        }
        return;
      }
      // Non‑iPhone: keep existing behavior
      if (this.isFullscreen) {
        await this.exitFullscreenSafely();
      } else {
        await this.enterFullscreen();
      }
    },
    async enterIPhoneSystemFullscreen() {
      const v = this.$refs && this.$refs.video;
      if (!v) return;
      try {
        if (v.readyState >= 1) {
          if (typeof v.webkitEnterFullscreen === 'function') v.webkitEnterFullscreen();
        } else {
          const once = () => {
            v.removeEventListener('loadedmetadata', once);
            try { if (typeof v.webkitEnterFullscreen === 'function') v.webkitEnterFullscreen(); } catch (_) { /* Ignore */ }
          };
          v.addEventListener('loadedmetadata', once, { once: true });
          v.load();
        }
      } catch (e) { console.error('iPhone system fullscreen failed', e); }
    },

    async enterFullscreen() {
      try {
        const el = (this.$el && this.$el.parentElement) || document.documentElement;
        if (!document.fullscreenElement && el && el.requestFullscreen) {
          await screenfull.request(el);
        }
        // Try landscape on mobile
        try {
          if (typeof window.screen !== 'undefined' && window.screen.orientation && window.screen.orientation.lock) {
            const isMobile = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (isMobile) {
              await window.screen.orientation.lock('landscape');
            }
          }
        } catch (_) { /* ignore */ }
        this.isFullscreen = true;
        try { sessionStorage.setItem('livevideo.fullscreen', '1'); } catch (_) { /* Ignore */ }
      } catch (e) {
        console.error('enterFullscreen failed', e);
      }
    },
    async exitFullscreenSafely() {
      if (this.isPseudoFullscreen) { await this.exitPseudoFullscreen(); return; }
      try {
        if (document.fullscreenElement && document.exitFullscreen) {
          await document.exitFullscreen();
        }
      } catch (_) { /* ignore */ }
      try {
        if (typeof window.screen !== 'undefined' && window.screen.orientation && window.screen.orientation.unlock) {
          window.screen.orientation.unlock();
        }
      } catch (_) { /* ignore */ }
      this.isFullscreen = false;
      try { sessionStorage.setItem('livevideo.fullscreen', '0'); } catch (_) { /* Ignore */ }
    },

    // --- Loading thumbnail helpers ---
    async loadPreviewImage() {
      try {
        if (!this.camera || !this.camera.id) {
          this.previewImage = '';
          return;
        }
        const img = await get(`camerapreview.${this.camera.id}`);
        this.previewImage = img || '';
      } catch (e) {
        console.warn('Failed to load preview image', e);
        this.previewImage = '';
      }
    },
    getLoadingBgStyle() {
      if (!this.previewImage) return null;
      return {
        backgroundImage: `url(${this.previewImage})`,
      };
    },
    // --- Janus teardown + gate ---
    teardownJanus() {
      try {
        this.janusDestroying = true;
        // push back connect allowance
        this.connectAllowedAt = Date.now() + this.connectDelayMs;
        // cancel pending timers
        if (this.connectTimer) { clearTimeout(this.connectTimer); this.connectTimer = null; }
        if (this.reconnectTimer) { clearTimeout(this.reconnectTimer); this.reconnectTimer = null; }
        // existing cleanup paths if present
        if (typeof this.stopStream === 'function') { try { this.stopStream(); } catch (e) { /* Ignore */ } }
        if (typeof this.cleanup === 'function') { try { this.cleanup(); } catch (e) { /* Ignore */ } }
        // best-effort explicit destroy if handles exist
        try {
          if (this.pluginHandle && this.pluginHandle.detach) {
            this.pluginHandle.detach({ /* Ignore */ });
          }
        } catch (e) { /* Ignore */ }
        try {
          if (this.janus && this.janus.destroy) this.janus.destroy();
        } catch (e) { /* Ignore */ }
        this.pluginHandle = null;
        this.janus = null;
      } finally {
        this.janusDestroying = false;
      }
    },
    forceDisconnect() {
      this.teardownJanus('forceDisconnect');
    },
    requestConnect() {
      if (this.janusDestroying) return;
      const wait = this.connectAllowedAt - Date.now();
      if (wait <= 0) {
        if (typeof this.initJanus === 'function') this.initJanus();
        else if (typeof this.connect === 'function') this.connect();
        return;
      }
      if (this.connectTimer) clearTimeout(this.connectTimer);
      this.connectTimer = setTimeout(() => {
        this.connectTimer = null;
        this.requestConnect('delayed');
      }, wait);
    },

    setState(next, opts = { /* Ignore */ }) {
      this.videoState = next;
      if (opts.error) this.videoError = String(opts.error);
      if (opts.janusError) this.lastJanusError = String(opts.janusError);
      // control watchdog
      if (next === 'buffering' || next === 'negotiating' || next === 'connecting') {
        if (this.startTimeoutId) clearTimeout(this.startTimeoutId);
        this.startTimeoutId = setTimeout(() => {
          this.fail('Timed out waiting for video stream to start');
        }, this.startTimeoutMs);
      } else if (this.startTimeoutId) {
        clearTimeout(this.startTimeoutId);
        this.startTimeoutId = null;
      }
    },
    fail(msg, janusError = '') {
      console.warn('[Video FAIL]', msg, janusError);
      this.setState('error', { error: msg, janusError });
      this.$store.dispatch('incrementAndSaveStat', ['videoFeedError']);
    },
    retryStream() {
      // reset state and rebuild Janus session
      try { this.stopStream(); } catch { /* nothing */ }
      try { if (this.janus) this.janus.destroy(); } catch { /* nothing */ }
      this.streaming = null;
      this.janus = null;
      this.lastJanusError = '';
      this.videoError = '';
      this.setState('connecting');
      this.initJanus();
    },

    async setPreviewExists() {
      this.previewExists = await this.havePhoto(this.camera.id);
      console.log('previewExists: ', this.previewExists);
    },
    lvMode() {
      this.skipDay(31);
    },
    // Tap to go back
    backTap() {
      if (this.dbTapBackwards) {
        this.playmode = 'vt';
        this.rewind({ rel: -20000, pause: 0 });
        if (this.dbTapForwards) clearTimeout(this.dbTapForwards);
        clearTimeout(this.dbTapBackwards);
        this.symbolShown = '<<';
      }
      this.dbTapBackwards = setTimeout(() => {
        this.dbTapBackwards = null;
        this.symbolShown = '';
      }, 500);
    },
    // Tap to go forward
    forwardTap() {
      if (this.dbTapForwards) {
        this.playmode = 'vt';
        console.log(new Date().getTime() - this.lastTimeStamp);
        if (new Date().getTime() - this.lastTimeStamp < 20000) this.switchToLiveview();
        else this.fastForward({ rel: 20000 });
        if (this.dbTapBackwards) clearTimeout(this.dbTapBackwards);
        clearTimeout(this.dbTapForwards);
        this.symbolShown = '>>';
      }
      this.dbTapForwards = setTimeout(() => {
        this.dbTapForwards = null;
        this.symbolShown = '';
      }, 500);
    },
    // Prevents double tapping causing user to zoom preventing action
    preventZoom(e) {
      const t2 = e.timeStamp;
      const t1 = e.currentTarget.dataset.lastTouch || t2;
      const dt = t2 - t1;
      const fingers = e.touches.length;
      e.currentTarget.dataset.lastTouch = t2;

      if (!dt || dt > 500 || fingers > 1) return; // not double-tap

      e.preventDefault();
      e.target.click();
    },
    togglePlay() {
      this.playing = !this.playing;
      if (this.playing === true) { this.pause(); } else { this.play(); }
    },

    // ---------- Janus lifecycle ----------
    initJanus() {
      // delay connects until allowed
      if (Date.now() < this.connectAllowedAt) {
        if (this.connectTimer) clearTimeout(this.connectTimer);
        const wait = this.connectAllowedAt - Date.now();
        this.connectTimer = setTimeout(() => {
          this.connectTimer = null;
          this.initJanus();
        }, wait);
        return;
      }
      this.setState('connecting');
      Janus.init({
        debug: 'all',
        dependencies: Janus.useDefaultDependencies({ adapter }),
        callback: () => this.createJanusInstance(),
      });
    },
    createJanusInstance() {
      if (!Janus.isWebrtcSupported()) {
        this.fail('No WebRTC (streaming) support in this browser');
        return;
      }

      this.janus = new Janus({
        server: this.server,
        apisecret: 'a2a2a2',
        iceServers: [
          { urls: 'stun:megakam.com:3478' },
          {
            urls: 'turn:megakam.com:3478?transport=udp',
            username: 'myuser',
            credential: 'mypass',
          },
        ],
        success: () => { this.attachJanus(); },
        error: (error) => {
          this.lastJanusError = String(error);
          if (this.janusRetries < this.maxJanusRetries) {
            this.janusRetries += 1;
            console.warn('Janus init error, retrying...', this.janusRetries, error);
            setTimeout(() => this.createJanusInstance(), 500);
          } else {
            this.fail('Video stream (Janus) initialization failed', error);
          }
        },
        destroyed: () => {
          if (this.videoState !== 'error') this.setState('connecting');
        },
      });
    },
    attachJanus() {
      const component = this;

      this.janus.attach({
        plugin: 'janus.plugin.streaming',
        opaqueId: 'tempest-1',

        success: (pluginHandle) => {
          component.streaming = pluginHandle;
          component.startStream();
        },

        error: (error) => {
          component.fail('Failed to attach streaming plugin', error);
        },

        // Helpful lower-level signals if available
        webrtcState: (on) => {
          if (on) {
            // Connected - likely in negotiating/buffering state until frames
            if (this.videoState !== 'playing') this.setState('negotiating');
          } else {
            this.fail('Video stream disconnected');
          }
        },
        iceState: (state) => {
          if (state === 'failed' || state === 'disconnected') {
            this.fail(`ICE (Connectivity) error: ${state}`);
          }
        },
        oncleanup: () => {
          // Peer connection cleaned up by Janus
          if (this.videoState !== 'error') {
            this.setState('connecting');
          }
        },

        onmessage: (msg, jsep) => {
          if (jsep !== undefined && jsep != null) {
            this.setState('negotiating');
            component.streaming.createAnswer({
              jsep,
              media: { audioSend: false, videoSend: false, data: true },
              success: (receiveJsep) => {
                Janus.debug('Got SDP!');
                console.log('GOT JSEP: ', receiveJsep);
                Janus.debug(receiveJsep);
                const body = { request: 'start' };
                component.streaming.send({ message: body, jsep: receiveJsep });
                // waiting for remote stream -> buffering until video really plays
                this.setState('buffering');
              },
              error: (error) => {
                Janus.error('WebRTC error:', error);
                console.log('ERROR: ', error);
                this.error = 'An error has occurred.';
              },
            });
          }
        },

        onremotestream: (stream) => {
          // Remote track received, but keep spinner up until the <video> is actually playing.
          Janus.attachMediaStream(component.$refs.video, stream);
          if (this.videoState !== 'error') this.setState('buffering');
          stream.getTracks().forEach((t) => {
            if (t && t.addEventListener) {
              t.addEventListener('unmute', (ev) => {
                this.setState('playing');
                console.log('[Capture] Track unmuted:', ev.target.kind);
                component.captureImage();
                setTimeout(() => component.captureImage(), 3000);
              });
            }
          });
        },

        ondataopen: (data) => {
          this.dataChannelOpen = true;
          console.log('Data Channel opened with data: ', data);
          this.$emit('sessionId', this.janus.getSessionId());
          this.getMediaReports();
          this.getEventsWithRetry();
          this.$store.dispatch('incrementAndSaveStat', ['datachannelOpened']);
        },

        ondata: (msg) => {
          if (JSON.parse(msg).events && JSON.parse(msg).events[0]?.event === 'id') {
            this.retryCount = 0;
            this.$store.dispatch('changeEvents', msg);
            if (this.firstInboxReceived) {
              this.firstInboxReceived = false;
              this.$store.dispatch('incrementAndSaveStat', ['inboxReceived']);
            }
          }
          this.processData(msg);
          awsInfo.rectangles = JSON.parse(msg);
          if (awsInfo.rectangles == null) return;
          this.drawOverlay();
        },
      });
    },
    getEventsWithRetry() {
      this.retryCount -= 1;
      console.log('Get event list retry count = ', this.retryCount);
      this.$store.dispatch('changeEvents', null);
      this.filter();
      setTimeout(() => {
        if (this.retryCount > 0) {
          this.getEventsWithRetry();
        }
      }, 1000);
    },

    startStream() {
      console.log('START STREAM');
      this.setState('connecting');
      const body = { request: 'watch', id: 1 };
      if (!this.streaming) {
        this.fail('Streaming handler not ready');
        return;
      }
      this.streaming.send({
        message: body,
        error: (e) => this.fail('Failed to send watch request', e),
        success: () => {
          // Watchdog: ensure we reach playing soon
          this.setState('negotiating');
        },
      });
    },
    stopStream() {
      if (this.streaming) {
        console.log('Stopping Stream');
        const body = { request: 'stop' };
        try { this.streaming.send({ message: body }); } catch { /* nothing */ }
        try { this.streaming.hangup(); } catch { /* nothing */ }
      }
    },

    // ---------- Video element event handlers ----------
    onVideoLoaded() {
      // we got metadata; keep spinner until canplay/playing
      if (this.videoState !== 'error') this.setState('buffering');
    },
    onVideoCanPlay() {
      if (this.videoState !== 'error') this.setState('buffering');
    },
    onVideoPlaying() {
      // This is the true “we are showing frames”
      this.setState('playing');
    },
    onVideoWaiting() {
      // Buffer underrun / waiting for data
      if (this.videoState !== 'error') this.setState('buffering');
    },
    onVideoElementError(e) {
      const mediaErr = this.$refs.video?.error;
      const codeMsg = mediaErr ? `MediaError code ${mediaErr.code}` : '';
      this.fail('Video tag reported an error', codeMsg || (e && e.message) || '');
    },

    handlePlay() {
      this.$emit('connected');
      if (this.showCanvas === false) this.showCanvas = true;
      this.$store.dispatch('incrementAndSaveStat', ['videoFeedStarted']);
      if (this.firstVideoPlay) {
        this.firstVideoPlay = false;
        const currentTime = Date.now();
        const timeToFirstFrame = currentTime - this.pageLoadTime;
        const addCameraStartTime = (timeToFirstFrame / 1000).toFixed(2);
        this.$store.dispatch('addCameraStartTime', addCameraStartTime);
      }
    },
    handlePause() {
      this.$store.dispatch('incrementAndSaveStat', ['videoFeedStopped']);
    },
    handleResize() {
      if (this.showCanvas === false) this.showCanvas = true;

      this.fitToolbar();
    },
    setupCanvas() {
      console.log('Setup Canvas');
      if (this.ctx == null) this.ctx = this.$refs.canvas.getContext('2d');
      this.ctx.canvas.width = this.$refs.video.clientWidth;
      this.ctx.canvas.height = this.$refs.video.clientHeight;
      this.captureImage();
    },

    // ---------- Overlay / data channel drawing ----------
    drawOverlay() {
      if (!this.draw) return;
      // Schedule to clear the overlay after 1 second with no updates.
      // And cancel prior timer if already running.
      const colours = ['red', 'lightgreen', 'lightblue', 'orange', 'magenta', 'yellow', 'cyan'];
      if (this.lifetimer) window.clearTimeout(this.lifetimer);
      this.lifetimer = window.setTimeout(this.clearOverlay, 1000);

      if (!awsInfo.rectangles) return;

      const c = this.$refs.canvas;
      const v = this.$refs.video;
      if (v === null || v.videoWidth === 0 || v.videoHeight === 0) return;

      const vw = v.videoWidth;
      const vh = v.videoHeight;
      const g = this.ctx;
      if (g) {
        g.clearRect(0, 0, c.width, c.height);
        g.lineWidth = 1.5;
        g.font = '20px Arial';
      }

      // awsInfo.rectangles appears to just be datachannel
      // data so only continue if rectangles exists
      if ('objectDetections' in awsInfo.rectangles === false) return;

      try {
        const obs = awsInfo.rectangles.objectDetections;
        let i = 0;
        obs.forEach((o) => {
          const colour = colours[i % colours.length];
          g.strokeStyle = colour;
          g.fillStyle = colour;

          const sx = (o.xmin / vw) * c.width;
          const sy = (o.ymin / vh) * c.height;
          const sw = (o.xmax / vw) * c.width;
          const sh = (o.ymax / vh) * c.height;

          g.strokeRect(sx, sy, sw - sx, sh - sy);
          g.fillText(`${o.class} ${o.confidence}%`, sx + 2, sy - 10);
          i += 1;
        });
      } catch (e) {
        console.red(e);
      }
    },
    clearOverlay() {
      awsInfo.rectangles = null;
      if (this.ctx == null) return;
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    },

    // ---------- Image capture ----------

    async captureImage() {
      console.log('[CAPTURE] initialising');
      const target = this.camera;
      const vid = this.$refs.video;
      if (!target || !target.id) { console.log('[CAPTURE] exit:target'); return; }
      if (Date.now() < this.captureBlockUntil) { console.log('[CAPTURE] exit:blocked'); return; }
      if (!vid || vid.readyState < 2) { console.log('[CAPTURE] exit:readiness'); return; }
      if (!this.draw || !this.ctx || !this.$refs.canvas) { console.log('[CAPTURE] exit:ctx'); return; }
      console.log('[CAPTURE] starting');
      this.capturingImage = true;
      this.clearOverlay();
      if (this.ctx) {
        const { video } = this.$refs;
        if (video && video.videoWidth && video.videoHeight) {
          this.ctx.canvas.width = video.videoWidth;
          this.ctx.canvas.height = video.videoHeight;
        }
        this.ctx.drawImage(this.$refs.video, 0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        const srcCanvas = this.$refs.canvas;
        const targetH = 130;
        const targetW = Math.round(srcCanvas.width * (targetH / srcCanvas.height));
        const off = document.createElement('canvas');
        off.width = targetW;
        off.height = targetH;
        const octx = off.getContext('2d', { alpha: false });
        octx.imageSmoothingEnabled = true;
        octx.imageSmoothingQuality = 'high';
        octx.drawImage(srcCanvas, 0, 0, targetW, targetH);
        const image = off.toDataURL('image/jpeg', 0.5); // JPEG output

        this.clearOverlay();
        this.capturingImage = false;
        const { id } = this.camera;
        set(`camerapreview.${id}`, image); // localStorage.setItem(`camerapreview.${id}`, image);
        console.debug('Updated preview image: ', image);
      }
    },

    // ---------- Data channel ----------
    async sendData(data) {
      if (this.streaming === null || this.dataChannelOpen === false) return;
      console.log('Sending Data');

      this.streaming.data({
        text: JSON.stringify(data),
        error: () => { },
        success: () => { },
      });
    },
    processData(message) {
      let data = null;

      try {
        data = JSON.parse(message);
      } catch (e) {
        console.log('Error in decoding data channel message to json: ', message);
      }

      if (data == null) return;

      if ('ts' in data === false) console.log('Data: ', data);

      if (data?.action?.command === 'healthCheck') {
        const statsData = data?.action?.data ?? { /* Ignore */ };
        this.$emit('statsResponse', statsData);
        return;
      }

      // Detect play / pause state
      if ('ts' in data) {
        if (this.firstStreamTime) {
          this.firstStreamTime = false;
          this.$store.dispatch('incrementAndSaveStat', ['streamTimeReceived']);
        }
        const currentTimeStamp = data.ts;
        if (this.ignoreTimestampMessages > 0) {
          this.ignoreTimestampMessages -= 1;
          this.lastTimeStamp = currentTimeStamp;
          return;
        }

        this.playing = 'pause' in data && data.pause === true;
        this.lastTimeStamp = currentTimeStamp;
      }

      if ('date' in data) this.currentDate = data.date;

      if ('response' in data) {
        if (data.response !== 'make-v' && data.response !== 'mmctrl') return;

        if (data?.response === 'mmctrl' && data?.data?.status === 'complete' && data?.data?.output.endsWith('.jpg')) {
          this.mmctrl_ok(data);
          return;
        }

        const { status } = data.data;

        if (this.clipStatus !== status) {
          this.clipStatus = status;
          this.$emit('clipStatus', status);
        }
      }
    },

    // ---------- Player controls ----------
    pause() {
      const data = { pause: -1 };
      if (this.playmode === 'lv') {
        data.pause = 1000 * 60 * 60 * 24;
        data.rel = 0;
      }
      this.playmode = 'vt';
      const message = {
        topic: 'cmd/devices/hilary-dev/data-channel-relay',
        destination: 'mplay',
        action: {
          command: 'vt',
          data,
        },
      };

      this.ignoreTimestampMessages = 1;
      this.sendData(message);
    },
    play() {
      this.playmode = 'vt';
      const message = {
        topic: 'cmd/devices/hilary-dev/data-channel-relay',
        destination: 'mplay',
        action: {
          command: 'vt',
          data: {
            pause: 0,
          },
        },
      };

      this.sendData(message);
    },

    filter() {
      const message = {
        topic: 'cmd/devices/tempest-dev/data-channel-relay',
        action: {
          command: 'qe',
          destination: `inbox-app/${this.camera.id}`,
          data: {
            from: this.filterTime,
            to: this.eventTo !== null && this.eventTo !== undefined ? this.eventTo : Date.now(),
          },
        },
      };
      this.sendData(message);
      if (this.firstInboxRequested) {
        this.firstInboxRequested = false;
        this.$store.dispatch('incrementAndSaveStat', ['inboxRequested']);
      }
    },
    rewind(iData) {
      const number = iData.rel > 0;
      this.playmode = 'vt';
      const data = iData ?? { rel: -5000, pause: 200 };
      const message = {
        topic: 'cmd/devices/hilary-dev/data-channel-relay',
        destination: 'mplay',
        action: {
          command: 'vt',
          data: {
            rel: data.rel,
            pause: data.pause,
            forward: number,
          },
        },
      };

      console.log('SENDING: ', JSON.stringify(message));

      this.sendData(message);
    },
    fastForward(iData) {
      this.playmode = 'vt';
      const data = iData ?? { rel: 5000 };

      const message = {
        topic: 'cmd/devices/hilary-dev/data-channel-relay',
        destination: 'mplay',
        action: {
          command: 'vt',
          data,
        },
      };

      this.sendData(message);
    },
    getMediaReports() {
      console.log('getMediaReports');
      const message = {
        topic: 'cmd/devices/hilary-dev/data-channel-relay',
        action: {
          destination: 'mplay',
          command: 'report',
          data: {
            ts: true,
            date: true,
            version: true,
            debug: true,
            source: true,
          },
        },
      };
      this.sendData(message);
      this.$store.dispatch('incrementAndSaveStat', ['streamTimeRequested']);
    },
    startSeekTask() {
      this.playmode = 'vt';
      console.log('Start Seek Task');
      if (this.seekTask != null) this.stopSeekTask();
      this.handleSeekTask();
      this.seekTask = setInterval(this.handleSeekTask, 100);
    },
    handleSeekTask() {
      console.log('Handle Seek Task');
      // allow the scrubber to affect the skip point from + 4 seconds to - 4 seconds
      const seekAmount = ((this.scrubber - 50) >= 0 ? 1000 : -1000)
        + Number.parseInt((((this.scrubber - 50) / 50) * 7) * 1000, 10);
      console.log(seekAmount);
      this.rewind({ rel: seekAmount, pause: 200 });
    },
    stopSeekTask() {
      console.log('Stop Seek Task');
      if (this.seekTask == null) return;
      clearInterval(this.seekTask);
      this.seekTask = null;
    },
    switchToLiveview() {
      this.playmode = 'lv';
      const message = {
        topic: 'cmd/devices/hilary-dev/data-channel-relay',
        destination: 'mplay',
        action: {
          command: 'lv',

        },
      };

      this.sendData(message);
    },
    async havePhoto(id) {
      const result = await keys();
      return result.indexOf(`camerapreview.${id}`) > -1;
    },
    getDeviceStats() {
      const message = {
        topic: 'cmd/devices/hilary-dev/data-channel-relay',
        action: {
          destination: 'health-monitor',
          command: 'healthCheck',
        },
      };
      this.sendData(message);
    },

    // ---------- Date / screenshot logic ----------
    parseDateTime(str) {
      // str looks like "DD.MM.YYYY HH:MM:SS"
      const [dmy, hms] = str.split(' ');
      const [d, m, y] = dmy.split('.').map(Number);
      const [H, M, S] = hms.split(':').map(Number);
      return new Date(y, m - 1, d, H, M, S);
    },
    formatDate(date) {
      const day = date.toLocaleDateString('en-GB', { weekday: 'short' });

      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();

      // Add leading zeros if necessary
      hours = hours < 10 ? `0${hours}` : hours;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;

      const formattedDate = `${day} ${hours}:${minutes}:${seconds}`;
      return formattedDate;
    },
    getCurrentDate() {
      return this.currentDate;
    },
    async doJpegCapture() {
      const ts = this.playmode === 'lv' ? Date.now() : this.lastTimeStamp;
      console.log('Make JPEG process begins at', ts);
      const startDate = new Date();

      const year = startDate.getFullYear();
      const month = String(startDate.getMonth() + 1).padStart(2, '0');
      const day = String(startDate.getDate()).padStart(2, '0');
      const hours = String(startDate.getHours()).padStart(2, '0');
      const minutes = String(startDate.getMinutes()).padStart(2, '0');
      const seconds = String(startDate.getSeconds()).padStart(2, '0');

      this.jpegFilename = `${this.camera?.name.replaceAll(' ', '-')}-${year}-${month}-${day}-${hours}-${minutes}-${seconds}.jpg`;

      // Send message to make-j
      const msg = {
        topic: 'cmd/devices/hilary-dev/data-channel-relay',
        destination: 'mmctrl',
        action: {
          command: 'make-j',
          data: {
            output: this.jpegFilename,
            source: this.camera.id,
            ts: {
              s: ts,
              iframesonly: false,
              qp: 0,
            },
            'rtc-osd': {
              x: 65,
              y: 95,
              height: 3,
              'time-adjust': -3600,
              text: '%Y/%m/%d %H:%M:%S',
            },
            'redaction-zones': [
            ],
            'text-osd': [
              {
                text: '',
                x: 40.2,
                y: 10,
                height: 9,
              },
            ],
          },
        },
      };

      this.sendData(msg);
      this.$emit('openScreenshotModal', this.jpegFilename);
    },
    async mmctrl_ok(data) {
      // Initiate file download
      const filename = data?.data?.output;

      if (this.cancelledScreenshots.includes(filename)) {
        const index = this.cancelledScreenshots.indexOf(filename);
        if (index > -1) this.cancelledScreenshots.splice(index, 1);
        await window.delete_file(filename);
        return;
      }

      await window.get_file(filename);
      this.$emit('screenshotCompleted');
      // await this.get_file(data?.data?.output);
      // console.log('Make JPEG process complete.');
    },
    cancelScreenshot(name) {
      this.cancelledScreenshots.push(name);
    },
    openDatePicker() {
      const input = this.$refs.dateInput;
      input.focus({ preventScroll: true });
      if (input.showPicker) input.showPicker();
      else input.click();
    },
    onDateSelected(event) {
      const { target } = event; // YYYY-MM-DD
      if (!target.value) return;

      // target.value is "YYYY-MM-DDTHH:MM" (no timezone).
      // Build a local Date explicitly to avoid Safari quirks:
      const [ymd, hm] = target.value.split('T');
      const [y, m, d] = ymd.split('-').map(Number);
      const [H, M] = hm.split(':').map(Number);
      const ts = Date.UTC(y, m - 1, d, H, M) + (new Date().getTimezoneOffset() * 60000);

      if (ts > new Date().getTime()) {
        target.value = null;
        return;
      }

      const dayStart = Date.UTC(y, m - 1, d, 0, 0, 0, 0);
      const dayEnd = dayStart + 86400000 - 1;

      this.$store.dispatch('selectEvent', ts);
      setTimeout(() => {
        this.$store.dispatch('selectEvent', null);
        this.$store.dispatch('changeStartTime', dayStart);
        this.$store.dispatch('changeEndTime', dayEnd);
      }, 750);

      // Refetch events for the new date range
      this.filter();

      // Reset input so same date can be reselected if needed
      target.value = null;
    },
    toggleFilter(filterType) {
      if (this.eventsEnabled[filterType]) this.eventsEnabled[filterType] = false;
      else this.eventsEnabled[filterType] = true;
    },
    async refreshEvents() {
      if (this.lastTimeStamp && new Date(this.lastTimeStamp).getDate() === new Date().getDate()) {
        this.$store.dispatch('changeEndTime', new Date().getTime());
      }
      this.$store.dispatch('changeEvents', null);
      this.$emit('refreshEvents');
    },
    skipDay(direction) {
      const day = 1000 * 60 * 60 * 24;
      const duration = direction * day;
      const newDate = this.lastTimeStamp + duration;
      const now = new Date().getTime();
      const clampedNewDate = Math.max(now - (30 * day), Math.min(newDate, now));

      if (clampedNewDate === now) {
        this.switchToLiveview();
      } else {
        this.playmode = 'vt';
        const data = { abs: clampedNewDate };
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data,
          },
        };
        this.sendData(message);
      }

      setTimeout(() => {
        const startOfDay = new Date(clampedNewDate).setHours(0, 0, 0, 0);
        console.warn(new Date(startOfDay));
        let endOfDay = startOfDay + (86400000 - 1);
        if (endOfDay - 1 > now) {
          endOfDay = now;
        }
        this.$store.dispatch('changeEndTime', endOfDay);
        this.$store.dispatch('changeStartTime', startOfDay);
        this.$store.dispatch('changeEvents', null);
        this.$nextTick(() => {
          this.$emit('refreshEvents');
        });
      }, 1000);
    },
    hardReload() {
      window.location.reload(true);
    },
  },
};
</script>

<style scoped>
.loadingPage {
  background: top / contain no-repeat;
  filter: grayscale(80%) brightness(0.6) blur(3px);
  backdrop-filter: brightness(0);
  top: 0;
  left: 0;
  position: absolute;
  height: 100%;
  max-height: 100%;
  width: 100%;
  z-index: 10;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.loadingPage.still-loading {
  opacity: 1;
}

.mediaTools.still-loading * {
  opacity: 0.5 ;
  pointer-events: none;
}

* {
  touch-action: manipulation;
}

.tapBack div {
  height: 100%;
  width: 40%;
}
.tapBack .symbol {
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.tapBack .symbol svg {
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.tapBack {
  display: flex;
  justify-content: space-between;
  top: 0;
  position: absolute;
  width: 100%;
  height: calc(100% - 38px - 36px);
  max-height: 100%;
  z-index: 19;
}

.play {
  background-image: url("data:image/svg+xml,%3Csvg width='23' height='23' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.15962 0.841309H1.76962C0.871365 0.841309 0.143188 1.56949 0.143188 2.46774V21.2149C0.143188 22.1131 0.871365 22.8413 1.76962 22.8413H7.15962C8.05787 22.8413 8.78605 22.1131 8.78605 21.2149V2.46774C8.78605 1.56949 8.05787 0.841309 7.15962 0.841309Z' fill='%23EAEBEC'/%3E%3Cpath d='M20.5168 0.841309H15.1268C14.2285 0.841309 13.5003 1.56949 13.5003 2.46774V21.2149C13.5003 22.1131 14.2285 22.8413 15.1268 22.8413H20.5168C21.415 22.8413 22.1432 22.1131 22.1432 21.2149V2.46774C22.1432 1.56949 21.415 0.841309 20.5168 0.841309Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");
}

.pause {
background-image: url("data:image/svg+xml,%3Csvg width='22' height='23' viewBox='0 0 22 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.0803 9.71909L2.36916 0.372901C2.11674 0.256068 1.83908 0.204161 1.56145 0.221906C1.28381 0.239651 1.01503 0.326484 0.779572 0.4745C0.544111 0.622515 0.349447 0.827014 0.2133 1.06938C0.077153 1.31174 0.00384762 1.58428 5.65776e-05 1.86217V20.5465C-0.00230074 20.8318 0.0690426 21.1128 0.207191 21.3625C0.34534 21.6121 0.545622 21.822 0.788679 21.9717C1.03174 22.1214 1.30935 22.206 1.59468 22.2172C1.88002 22.2284 2.16342 22.1659 2.41751 22.0358L21.0803 12.6896C21.3567 12.5509 21.5892 12.3382 21.7516 12.0753C21.914 11.8123 22 11.5093 22 11.2003C22 10.8913 21.914 10.5884 21.7516 10.3254C21.5892 10.0624 21.3567 9.84967 21.0803 9.71103V9.71909Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");
}

.Lv {
  width: 32px;
  height: 32px;
  min-width: 32px;
  background-color: transparent;
  font-weight: 500;
  font-size: 20px;
  transition: color 0.2s ease;
}

.redHighlight {
  color: var(--error);
}

.playPause {
  background-repeat: no-repeat;
  background-position: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  background-color: transparent;
}

.playPause svg {
  width: 100%;
  height: 100%;
}

.range {
  width: clamp(0px, 70vw, 600px);
  background-color: var(--text);
}

.mediaTools {
  justify-content: space-between;
  display: flex;
  align-items: center;
  height: 38px;
  background: var(--surface);
  width: 100%;
  max-height: 100%;
  z-index: 20;
}

.timelineScrubberSlot {
  width: 100%;
  height: 36px;
  z-index: 20;
}

.video-wrapper {
  touch-action: pan-y;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url(../assets/black.jpeg);
  overflow: hidden;
  max-height: 100%;
}

.video {
  max-width: 100%;
  max-height: calc(100% - 74px);
}

.loading {
  position: absolute;
  z-index: 12;
}

.canvas {
  position: absolute;
  top: 0;
  z-index: -1000;
}

.time-text {
  min-width: 0;
  flex: 0 0 auto;
  display: block;
  text-align: center;
  user-select: none;
  text-wrap: wrap;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  display: flex;
  position: relative;
}

@import url('https://fonts.googleapis.com/css2?family=Source+Code+Pro&display=swap');
.time-text span {
  font-family: "Source Code Pro", monospace;
  font-size: 0.9rem;
}

.time-text .DDMMYYYY+.HHMMSS {
  margin-left: 6px;
}

.time-text .DDMMYYYY {
  width: 30px;
}

.time-text .HHMMSS {
  width: 70px;
  text-align: right;
}

.hide-time-text {
  visibility: hidden;
}

@media only screen and (max-width: 420px) {
  .image-capture-btn {
    display: none !important;
  }
}
.image-capture-btn {
  background-color: transparent;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--%3E%3Cpath fill='%23ffffff' d='M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 22px 22px;
  height: 42px;
  width: 42px;
  min-width: 36px;
}

.errorOverlay {
  position: absolute;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(4, 5, 12, 0.65);
}

.errorCard {
  min-width: 280px;
  max-width: 90vw;
  background: var(--surface);
  color: var(--text);
  border-radius: var(--border-radius);
  padding: 16px 18px;
  box-shadow: var(--shadow);
}

.errorTitle {
  font-weight: 700;
  margin-bottom: 8px;
}

.errorBody {
  font-size: 14px;
  opacity: 0.9;
}

.errorDetails {
  margin-top: 6px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  opacity: 0.8;
}

.errorDetails button {
  border: var(--border);
  background: var(--accent);
  border-radius: var(--border-radius);
  padding: 0.25rem 1rem;
}

.errorActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.fullscreenBtn {
  width: 36px;
  height: 36px;
  min-width: 36px;
  background: none;
  border: none;
  cursor: pointer;
}

.fullscreenBtn svg {
  margin-top: 4px;
}

.barPlaceholder {
  flex: 1 1 0px;
  min-height: 1px;
}

.pseudo-fullscreen {
  position: fixed !important;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: #000;
  padding: 0 !important;
  margin: 0 !important;
}
.pseudo-fullscreen .video {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
}
/* Safe area for iOS notch */
.pseudo-fullscreen {
  padding-top: constant(safe-area-inset-top);
  padding-left: constant(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
}

/* Responsive sizing behaviour for the date/time area */
.time-text { white-space: nowrap; }

.portraitHide {
  display: none;
}

.isFullscreen .portraitHide {
  display: inline;
}

.filters {
  display: flex;
  align-items: center;
  gap: .25rem;
  padding: 0 0.5rem 0 0.5rem;
}
.filterIcon {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 60%;
  height: 28px;
  width: 28px;
  border: var(--border);
  border-radius: 50%;
  transition: border-color 0.25s ease;
}
.filterIcon.enabled {
  border-color: var(--accent);
}

.human {
background-image: url("data:image/svg+xml,%3Csvg width='34' height='25' viewBox='0 0 34 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.488647 0.231934V2.48193C0.488647 8.70693 4.04621 14.1519 9.34231 17.1819V24.2319H33.4886V21.2319C33.4886 17.2419 24.9086 15.2319 20.6106 15.2319H20.2082C12.5618 15.2319 6.12279 9.23193 6.12279 2.48193V0.231934H0.488647ZM20.6106 0.231934C18.9029 0.231934 17.2651 0.864074 16.0575 1.98929C14.85 3.11451 14.1716 4.64063 14.1716 6.23193C14.1716 7.82323 14.85 9.34936 16.0575 10.4746C17.2651 11.5998 18.9029 12.2319 20.6106 12.2319C22.3183 12.2319 23.9561 11.5998 25.1637 10.4746C26.3712 9.34936 27.0496 7.82323 27.0496 6.23193C27.0496 4.64063 26.3712 3.11451 25.1637 1.98929C23.9561 0.864074 22.3183 0.231934 20.6106 0.231934Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");}
.car {
background-image: url("data:image/svg+xml,%3Csvg width='34' height='29' viewBox='0 0 34 29' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.1968 10.2336L28.9396 3.84963C28.6122 2.92015 27.9824 2.1116 27.1397 1.53886C26.297 0.966116 25.2842 0.658311 24.2454 0.659182H9.20067C8.16181 0.658311 7.14909 0.966116 6.30638 1.53886C5.46368 2.1116 4.83386 2.92015 4.50642 3.84963L2.24922 10.2336C1.64899 10.4704 1.1364 10.8692 0.775883 11.3798C0.415368 11.8905 0.223022 12.4902 0.223022 13.1036V20.8814C0.223022 22.0294 0.889622 23.0218 1.87302 23.5616V27.1036C1.87302 27.5162 2.04686 27.9118 2.3563 28.2036C2.66573 28.4953 3.08542 28.6592 3.52302 28.6592H5.17302C5.61063 28.6592 6.03031 28.4953 6.33975 28.2036C6.64918 27.9118 6.82302 27.5162 6.82302 27.1036V23.9925H26.623V27.1036C26.623 27.5162 26.7969 27.9118 27.1063 28.2036C27.4157 28.4953 27.8354 28.6592 28.273 28.6592H29.923C30.3606 28.6592 30.7803 28.4953 31.0897 28.2036C31.3992 27.9118 31.573 27.5162 31.573 27.1036V23.5616C32.0736 23.291 32.4897 22.9007 32.7794 22.4302C33.0691 21.9596 33.2221 21.4254 33.223 20.8814V13.1036C33.223 12.4902 33.0307 11.8905 32.6702 11.3798C32.3096 10.8692 31.7971 10.4704 31.1968 10.2336ZM9.20067 3.77029H24.2437C24.9549 3.77029 25.5852 4.19651 25.8096 4.83429L27.6345 9.99251H5.81157L7.63482 4.83429C7.7443 4.52442 7.95446 4.25489 8.2355 4.06391C8.51655 3.87294 8.85423 3.77021 9.20067 3.77029V3.77029ZM5.99802 19.3258C5.67289 19.3257 5.35097 19.2653 5.05063 19.1479C4.75029 19.0305 4.47742 18.8585 4.24759 18.6417C4.01777 18.4248 3.83549 18.1675 3.71117 17.8842C3.58685 17.601 3.52291 17.2975 3.52302 16.991C3.52313 16.6844 3.58728 16.3809 3.7118 16.0978C3.83632 15.8146 4.01878 15.5574 4.24876 15.3407C4.47874 15.124 4.75173 14.9522 5.05215 14.835C5.35257 14.7178 5.67454 14.6575 5.99967 14.6576C6.6563 14.6578 7.28595 14.9039 7.7501 15.3418C8.21426 15.7797 8.47489 16.3735 8.47467 16.9925C8.47445 17.6116 8.2134 18.2052 7.74894 18.6428C7.28447 19.0803 6.65465 19.3261 5.99802 19.3258V19.3258ZM27.448 19.3258C27.1229 19.3257 26.801 19.2653 26.5006 19.1479C26.2003 19.0305 25.9274 18.8585 25.6976 18.6417C25.4678 18.4248 25.2855 18.1675 25.1612 17.8842C25.0368 17.601 24.9729 17.2975 24.973 16.991C24.9731 16.6844 25.0373 16.3809 25.1618 16.0978C25.2863 15.8146 25.4688 15.5574 25.6988 15.3407C25.9287 15.124 26.2017 14.9522 26.5022 14.835C26.8026 14.7178 27.1245 14.6575 27.4497 14.6576C28.1063 14.6578 28.7359 14.9039 29.2001 15.3418C29.6643 15.7797 29.9249 16.3735 29.9247 16.9925C29.9245 17.6116 29.6634 18.2052 29.1989 18.6428C28.7345 19.0803 28.1047 19.3261 27.448 19.3258V19.3258Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");}
.refresh {
  background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 2C8.02093 2 6.20188 2.72229 4.80469 3.91667C4.73465 3.97242 4.67657 4.0417 4.63388 4.12039C4.5912 4.19907 4.5648 4.28554 4.55626 4.37465C4.54771 4.46376 4.5572 4.55367 4.58415 4.63903C4.6111 4.72439 4.65497 4.80345 4.71313 4.8715C4.77129 4.93954 4.84256 4.99518 4.92268 5.03509C5.00281 5.075 5.09015 5.09837 5.1795 5.1038C5.26885 5.10923 5.35838 5.09661 5.44275 5.0667C5.52712 5.03678 5.6046 4.99019 5.67057 4.92969C6.83605 3.9334 8.3444 3.33333 10 3.33333C13.4644 3.33333 16.3007 5.95862 16.6341 9.33333H14.6667L17.3333 13.3333L20 9.33333H17.9661C17.6253 5.23444 14.1852 2 10 2ZM2.66667 6.66667L0 10.6667H2.03385C2.37472 14.7656 5.81477 18 10 18C11.9791 18 13.7981 17.2777 15.1953 16.0833C15.2653 16.0276 15.3234 15.9583 15.3661 15.8796C15.4088 15.8009 15.4352 15.7145 15.4437 15.6253C15.4523 15.5362 15.4428 15.4463 15.4159 15.361C15.3889 15.2756 15.345 15.1965 15.2869 15.1285C15.2287 15.0605 15.1574 15.0048 15.0773 14.9649C14.9972 14.925 14.9099 14.9016 14.8205 14.8962C14.7312 14.8908 14.6416 14.9034 14.5573 14.9333C14.4729 14.9632 14.3954 15.0098 14.3294 15.0703C13.164 16.0666 11.6556 16.6667 10 16.6667C6.53563 16.6667 3.69934 14.0414 3.36589 10.6667H5.33333L2.66667 6.66667Z' fill='white'/%3E%3C/svg%3E%0A");
}

.filterSpacer {
  height: 30px;
  width: 1px;
  border: var(--border);
  border-width: 1px;
  box-sizing: border-box;
}

.daySkip, .daySkip svg {
  background: none;
  width: 1.5rem;
  height: 1.5rem;
}
</style>
